<mat-card>
    <div *ngFor="let group of this.functionalitygroups">
        <div *ngIf="group?.Features?.length > 0 || group?.Children?.length > 0">
            <div style="display: flex; align-items: flex-start; flex-flow: row wrap">
                <div style="display: flex; align-items: flex-start; flex-flow: row wrap" *ngFor="let feature of group.Features">
                    <div>
                        <span class="singleFeatureTitle">{{ feature.Description }}</span>
                        <div class="featureDescriptionMWPack">{{ getFeatureDataSheetDetail(feature.Fragment) }}</div>
                    </div>
                </div>
            </div>
            <div *ngFor="let groupChild of group.Children">
                <div *ngIf="groupChild.Features.length > 0">
                    <div style="display: flex; align-items: flex-start; flex-flow: row wrap">
                        <div
                            style="display: flex; align-items: flex-start; flex-flow: row wrap"
                            *ngFor="let feature of groupChild.Features"
                        >
                            <div>
                                <span class="singleFeatureTitle">{{ feature.Description }}</span>
                                <div class="featureDescriptionMWPack">{{ getFeatureDataSheetDetail(feature.Fragment) }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</mat-card>
